import ListTenants from './ListTenants';

export default ListTenants;
